import media from "css-in-js-media";
import React, { useEffect, useState } from "react";
import { HiMiniChevronDoubleUp } from "react-icons/hi2";
import styled from "styled-components";

const StyledBackToTopButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  margin: 0 auto;

  z-index: 1000;
  background: var(--colour-grey-5);
  color: var(--colour-dark-grey);
  border: none;
  padding: 1rem 2rem;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 2rem 2rem 0 0;
  transition: opacity 0.3s;

  &:focus-visible {
    outline: 2px solid var(--colour-grey-5);
    outline-offset: 2px;
  }

  ${media(">desktop")} {
    display: none;
  }
`;

export function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 100);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <StyledBackToTopButton
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
    >
      <HiMiniChevronDoubleUp /> To top
    </StyledBackToTopButton>
  );
}
